module.exports = __webpack_public_path__ + "static/team-saurabh-sharma-e6abcee0de2bb51e4f8d86f3eef1664b.jpeg";